<template>
  <div>
    <tabs
      :links="userTabLinks"
      :mode="'emitter'"
      :current-tab="tab"
      @changeView="tab = $event"
      class="is-border-bottom">
    </tabs>
    <template v-if="tab === 'UserOptions'">
      <user-options-list :props-tab="tab"></user-options-list>
    </template>
    <template v-if="tab === 'UserReservations'">
      <user-reservations-list :props-tab="tab"></user-reservations-list>
    </template>
    <template v-if="tab === 'UserContact'">
      <user-contact-list :props-tab="tab"></user-contact-list>
    </template>
    <template v-if="tab === 'UserTeam'">
      <user-team-list
        :source-user="currentUser"
        :source-user-team="currentUser.team"
        :props-tab="tab"></user-team-list>
    </template>
    <template v-if="tab === 'UserGroupes'">
      <user-groupes-list
        :source-user-groups="userGroups"
        :props-tab="tab"></user-groupes-list>
    </template>
    <template v-if="tab === 'LotWishlistList'">
      <lot-wishlist-list :props-tab="tab"></lot-wishlist-list>
    </template>
    <template v-if="tab === 'UserRdvs'">
      <user-rdvs-list :props-tab="tab"></user-rdvs-list>
    </template>
    <template v-if="tab === 'UserStats'">
      <user-stats
        :source-user="currentUser"
        :props-tab="tab"></user-stats>
    </template>
  </div>
</template>

<script>
import { User } from '@/mixins'
export default {
  name: 'UserTab',
  components: {
    UserStats: () => import('@/components/users/UserVuePanel/UserStats'),
    UserContactList: () => import('@/components/users/UserVuePanel/UserContactList'),
    UserTeamList: () => import('@/components/users/UserVuePanel/UserTeamList'),
    UserOptionsList: () => import('@/components/users/UserVuePanel/UserOptionsList'),
    UserReservationsList: () => import('@/components/users/UserVuePanel/UserReservationsList'),
    UserGroupesList: () => import('@/components/users/UserVuePanel/UserGroupesList'),
    LotWishlistList: () => import('@/components/lots/LotWishlistList'),
    UserRdvsList: () => import('@/components/users/UserVuePanel/UserRdvsList')
  },
  mixins: [User],
  data () {
    return {
      tab: ''
    }
  },
  created () {
    if ('tab' in this.$route.params) {
      this.tab = this.$route.params.tab
    } else if (!(this.userView in this.userTabLinks.map(x => x.link))) {
      if (this.statsEnabled) {
        this.tab = 'UserStats'
      } else {
        this.tab = 'UserOptions'
      }
    }
  }
}
</script>
